/**
 * decide-ai.js —— 一页纸决策 · AI 疏导组件（第二段，仅场景页随 ui.min.js 之后加载）
 * ---------------------------------------------------------------------------
 * 工具站 feedback.js 的「常驻入口」改造版（复制而非引用，改动点都在注释里）：
 *   - 去掉「解决了/没解决」主行、快捷标签、结果区注入三段（决策族入口常驻、直接聊）；
 *   - 上下文换成「问卷快照 + 判分快照」（DZ_LAST，由 decide.js 生成结果时写入）；
 *   - 文案硬编码中文（决策站仅中文部署，无语言包层）；错误码协议与工具站一致。
 * 会话流 / 追问 / SSE 流式 / 👍👎 评价 / 布局零位移口径 逐字保留（样式吃 tools.min.css）。
 */
(function (global) {
  'use strict';

  var doc = global.document;
  var UI = global.DZ_UI || {};
  var el = UI.el || function (t, c) { var n = doc.createElement(t); if (c) { n.className = c; } return n; };
  var span = UI.span || function (c, t) { var n = el('span', c); n.textContent = t; return n; };
  var iconEl = UI.icon || function () { return el('span', ''); };
  var toast = UI.toast || function () { /* 无 ui.min.js 时静默（不该发生：同页加载） */ };

  /* 错误码 → 中文文案（协议与工具站 Feedback::fail 一致） */
  function failMsg(res, fallback) {
    var code = (res && res.code) ? String(res.code) : '';
    var map = {
      fbTooFrequent:  '提交太频繁了，休息一下再试',
      fbBadOrigin:    '请求来源不对，请在本站页面内操作',
      fbUnknownTool:  '该决策单暂不支持疏导',
      fbDisabled:     '疏导功能暂未开启',
      fbBadParams:    '请求参数不对，请刷新后重试',
      fbNotFound:     '这条记录不在了，请重新提问',
      fbNoAnswer:     '这条还没有 AI 回答，无法评价',
      fbRateFail:     '评价失败，请稍后再试',
      fbAborted:      '回答中断，请再问一次',
      fbAiUnavailable:'AI 暂时没能回答，稍后再试',
      fbSubmitFail:   '提交失败，请稍后再试'
    };
    return map[code] || fallback;
  }

  /* 「为什么没有 AI 回答」：额度用完 ≠ AI 坏了，必须分开说（工具站教训） */
  function skipMsg(skip) {
    if (skip === 'quota_ip') {
      return 'AI 疏导这一小时的公共额度用完了，你的问题已经记下了；过一会儿可以继续追问。';
    }
    if (skip === 'quota_day') {
      return 'AI 疏导今天的公共额度用完了，明天可继续。问卷与打印不受影响。';
    }
    if (skip === 'ai_fail') {
      return 'AI 暂时没能回答，稍后再试可以继续问。';
    }
    return '';
  }

  function textOf(node) {
    return node ? String(node.textContent || '').replace(/\s+/g, ' ').trim() : '';
  }

  /* AI 的上下文：问卷快照（label=值）+ 判分快照（DZ_LAST）。
     双通道（2026-09-24）：优先 DZ_LAST（生成后全量快照），未生成就先聊时
     退读 DZ_DRAFT（decide.js 点选/输入实时同步的草稿），都没有再扫 DOM 兜底 */
  function collectContext(section) {
    try {
      var parts = [];
      var scene = doc.querySelector('[data-dz-scene]');
      var last = global.DZ_LAST || null;
      var snap = (last && last.answers && last.labels) ? last
        : ((global.DZ_DRAFT && global.DZ_DRAFT.answers && global.DZ_DRAFT.labels) ? global.DZ_DRAFT : null);
      if (snap) {
        /* 步进问卷：单题视图下 DOM 只有当前题，全量答案在生成时随判分快照落 DZ_LAST——
           这里直接读（题名用配置原文），不再扫 DOM */
        var pairs = [];
        for (var k in snap.answers) {
          if (!Object.prototype.hasOwnProperty.call(snap.answers, k)) { continue; }
          var av = String(snap.answers[k] || '').trim();
          if (av === '') { continue; }
          pairs.push((snap.labels[k] || k) + '=' + av.slice(0, 200));
        }
        if (pairs.length) { parts.push('他填写的情况：' + pairs.join('；')); }
      } else if (scene && !section.contains(scene)) {
        var inputs = [];
        var els = scene.querySelectorAll('input, select, textarea');
        for (var i = 0; i < els.length && inputs.length < 12; i++) {
          var f = els[i];
          if (!f.id || f.disabled) { continue; }
          /* 平铺问卷：select/textarea 直读；radio 组只收已勾选项，题名回退到 dz-cap-<name> */
          if (f.type === 'radio' && !f.checked) { continue; }
          var v = String(f.value == null ? '' : f.value).trim();
          if (v === '') { continue; }
          var lb = doc.querySelector('label[for="' + f.id + '"]');
          if (!lb && f.type === 'radio' && f.name) { lb = doc.getElementById('dz-cap-' + f.name); }
          var name = lb ? textOf(lb) : f.id;
          inputs.push(name + '=' + v.slice(0, 200));
        }
        if (inputs.length) { parts.push('他填写的情况：' + inputs.join('；')); }
      }
      if (last && last.slug) {
        /* 两难标签走场景 cfg.resultUI（#127 起），缺省老版口径「留下/离开」 */
        var sc = (global.DZ_SCENES || {})[last.slug] || {};
        var scUi = sc.resultUI || {};
        var stayName = scUi.stayName || '留下';
        var goName = scUi.goName || '离开';
        var line = '判分快照：「' + stayName + '」合计 ' + last.stay + ' 分，「' + goName + '」合计 ' + last.leave + ' 分，两边只差 ' + Math.abs(last.stay - last.leave) + ' 分';
        /* dims/diff 随 DZ_LAST 来（decide.js 生成时挂上）：取 |gap| 前 2 维直接告诉
           AI 分差来源——模型不用再从选项原文推理，回答可精确引用纸面数据 */
        if (last.dims && last.dims.length) {
          var sorted = last.dims.slice().sort(function (a, b) { return Math.abs(b.gap) - Math.abs(a.gap); });
          var top = [];
          for (var d = 0; d < sorted.length && top.length < 2; d++) {
            if (!sorted[d].gap) { break; }
            top.push('【' + sorted[d].label + '】' + (sorted[d].gap > 0 ? goName + '高 ' : stayName + '高 ') + Math.abs(sorted[d].gap) + ' 分');
          }
          if (top.length) { line += '，分差主要来自' + top.join('、'); }
        }
        parts.push(line);
      }
      return parts.join('\n').slice(0, 1200);
    } catch (e) { return ''; }
  }

  function pageSlug() {
    var segs = String(global.location && global.location.pathname || '').split('/');
    for (var i = segs.length - 1; i >= 0; i--) {
      if (segs[i] !== '') { return segs[i]; }
    }
    return '';
  }

  function postJSON(url, data) {
    var body = JSON.stringify(data);
    if (typeof global.fetch === 'function') {
      return global.fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body
      }).then(function (res) { return res.json(); });
    }
    return new Promise(function (resolve, reject) {
      try {
        var xhr = new global.XMLHttpRequest();
        xhr.open('POST', url, true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.onload = function () {
          try { resolve(JSON.parse(xhr.responseText)); } catch (e) { reject(e); }
        };
        xhr.onerror = function () { reject(new Error('network')); };
        xhr.send(body);
      } catch (e) { reject(e); }
    });
  }

  /* SSE 流式：自攒缓冲按 \n\n 切事件（分片不按事件对齐）；看门狗 45s 防前端干等 */
  function postStream(url, data, onChunk, onMeta) {
    var payload = data;
    payload.stream = 1;
    return global.fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'text/event-stream' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res || !res.body || typeof res.body.getReader !== 'function') {
        throw new Error('NO_STREAM');
      }
      var reader  = res.body.getReader();
      var decoder = new global.TextDecoder('utf-8');
      var buf = '';
      var rawAll = '';
      var final = null;

      var idle = null;
      function arm() {
        if (idle) { global.clearTimeout(idle); }
        idle = global.setTimeout(function () {
          try { reader.cancel(); } catch (e) { /* 忽略 */ }
        }, 45000);
      }
      function disarm() {
        if (idle) { global.clearTimeout(idle); idle = null; }
      }
      function handleEvent(block) {
        var lines = block.replace(/\r/g, '').split('\n');
        var name = 'message';
        var dataLine = '';
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].indexOf('event:') === 0) { name = lines[i].slice(6).trim(); }
          else if (lines[i].indexOf('data:') === 0) { dataLine += lines[i].slice(5).trim(); }
        }
        if (dataLine === '') { return; }
        var parsed = null;
        try { parsed = JSON.parse(dataLine); } catch (e) { return; }
        if (!parsed) { return; }
        if (name === 'chunk') {
          if (parsed.text) { onChunk(String(parsed.text)); }
        } else if (name === 'meta') {
          if (onMeta) { onMeta(parsed.id); }
        } else if (name === 'done' || name === 'error') {
          final = parsed;
        }
      }
      function pump() {
        return reader.read().then(function (r) {
          if (r.done) {
            disarm();
            if (!final && rawAll.trim() !== '') {
              try {
                var j = JSON.parse(rawAll.trim());
                if (j && typeof j.ok !== 'undefined') { final = j; }
              } catch (e) { /* 非 JSON 走兜底 */ }
            }
            return final || { ok: false, code: 'fbAborted' };
          }
          arm();
          var text = decoder.decode(r.value, { stream: true });
          rawAll += text;
          buf += text;
          var idx;
          while ((idx = buf.indexOf('\n\n')) >= 0) {
            handleEvent(buf.slice(0, idx));
            buf = buf.slice(idx + 2);
          }
          return pump();
        });
      }
      arm();
      return pump();
    });
  }

  function scrollToSection(section) {
    try { section.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { /* 老浏览器 */ }
  }

  /* 只聚焦不滚动：流式收尾后卡片长高，裸 focus 会把页面瞬移滚走（工具站实测教训） */
  function focusQuiet(node) {
    if (!node) { return; }
    try { node.focus({ preventScroll: true }); } catch (e) { node.focus(); }
  }

  function mountFeedback(section) {
    var byHook = function (hook) { return section.querySelector('[data-feedback-' + hook + ']'); };
    var form     = byHook('form');
    var chat     = byHook('chat');
    var turnsBox = byHook('turns');
    var done     = byHook('done');
    var text     = byHook('text');
    var send     = byHook('send');
    var sendLabel= byHook('send-label');
    var ask      = byHook('ask');
    var askSend  = byHook('ask-send');
    var errBox   = byHook('error');
    var endpoint = section.getAttribute('data-endpoint') || '';
    var rateEndpoint = section.getAttribute('data-rate-endpoint') || '';

    var SEND_LABEL = '聊聊我的纠结';
    var SEND_BUSY  = '思考中…';
    var finished = false;
    var busy = false;
    var turns = [];

    function aiOn() { return section.getAttribute('data-ai') === '1'; }
    function streamOn() {
      return section.getAttribute('data-stream') === '1'
        && typeof global.ReadableStream === 'function'
        && typeof global.TextDecoder === 'function'
        && typeof global.fetch === 'function';
    }

    function inlineError(msg) {
      if (!errBox) { if (msg) { toast(msg); } return; }
      if (msg) {
        errBox.textContent = msg;
        errBox.hidden = false;
      } else if (!errBox.hidden) {
        errBox.hidden = true;
        errBox.textContent = '';
      }
    }

    function setBusy(on) {
      busy = on;
      if (send) {
        send.disabled = on;
        if (sendLabel) { sendLabel.textContent = on ? SEND_BUSY : SEND_LABEL; }
      }
      if (askSend) {
        askSend.disabled = on;
        askSend.textContent = on ? '追问中…' : '追问';
      }
      if (text) { text.readOnly = on; }
      if (ask) { ask.readOnly = on; }
      if (form) { form.setAttribute('aria-busy', on ? 'true' : 'false'); }
      if (chat) { chat.setAttribute('aria-busy', on ? 'true' : 'false'); }
    }

    function showChat() {
      if (form) { form.hidden = true; }
      if (done) { done.hidden = true; }
      if (chat) { chat.hidden = false; }
    }
    function showDone() {
      if (form) { form.hidden = true; }
      if (chat) { chat.hidden = true; }
      if (done) { done.hidden = false; }
    }

    /* 感谢态（无 AI 回答的终态）：如实说明原因，不装成功 */
    function finishThanks(msg, tone) {
      if (!done) { return; }
      done.textContent = '';
      done.className = 'tool-feedback-done is-thanks';
      var box = el('div', tone === 'warn' ? 'tool-feedback-thanks is-warn' : 'tool-feedback-thanks');
      var line = el('p', 'tool-feedback-done-line');
      line.appendChild(iconEl(tone === 'warn' ? 'alert-circle' : 'check-circle'));
      line.appendChild(span('', msg || '已收到，感谢你的分享。'));
      box.appendChild(line);
      done.appendChild(box);
      showDone();
    }

    /* 评价行：生成即 pending（半截回答不该被评价）；id 惰性取（流式要等 meta） */
    function rateRow(idOf) {
      var row = el('div', 'tool-feedback-rate is-pending');
      row.setAttribute('data-feedback-rate', '');
      row.appendChild(span('tool-feedback-rate-q', '这个回答有用吗？'));
      row.appendChild(rateBtn(idOf, 1, '有用', 'thumb-up'));
      row.appendChild(rateBtn(idOf, 0, '没用', 'thumb-down'));
      return row;
    }
    function rateBtn(idOf, helpful, label, iconName) {
      var btn = el('button', 'tool-btn tool-btn--sm tool-feedback-rate-btn');
      btn.type = 'button';
      btn.disabled = true;
      btn.setAttribute(helpful === 1 ? 'data-feedback-rate-up' : 'data-feedback-rate-down', '');
      btn.appendChild(iconEl(iconName));
      btn.appendChild(span('', label));
      btn.addEventListener('click', function () { sendRate(idOf(), helpful, btn); });
      return btn;
    }
    function sendRate(id, helpful, btn) {
      var row = btn.parentNode;
      if (!id) { return; }
      /* 标记属性值为空串：必须 hasAttribute 判断（!getAttribute 会把评价静默挡掉） */
      if (!rateEndpoint || !row || !row.hasAttribute('data-feedback-rate') || row.getAttribute('data-rated')) { return; }
      row.setAttribute('data-rated', '1');
      postJSON(rateEndpoint, { id: id, helpful: helpful }).then(function (res) {
        if (res && res.ok) {
          markRated(row, helpful);
          toast('已记录，谢谢！');
        } else {
          row.removeAttribute('data-rated');
          toast(failMsg(res, '评价失败，请稍后再试'));
        }
      }).catch(function () {
        row.removeAttribute('data-rated');
        toast('评价失败，请稍后再试');
      });
    }
    function markRated(row, helpful) {
      row.textContent = '';
      row.className = helpful === 1 ? 'tool-feedback-rate is-rated' : 'tool-feedback-rate is-rated is-down';
      row.appendChild(iconEl(helpful === 1 ? 'thumb-up' : 'thumb-down'));
      row.appendChild(span('', helpful === 1 ? '已记录「有用」，谢谢！' : '已记录「没用」，我们会改进这类回答。'));
    }

    /**
     * AI 生成内容的隐式标识（《人工智能生成合成内容标识办法》2025-09-01 施行）。
     * 显式标识 = 页面上用户看得见的「由 AI 生成」免责条（answerTag）；
     * 隐式标识 = 机器可读的元数据——服务提供者 + 内容编号，写在轮次容器上。
     * 两者缺一不可：只有文本免责条时，抓取方/审计方拿不到这段内容是 AI 生成的证据。
     */
    function aiProvider() {
      var m = doc.querySelector ? doc.querySelector('meta[name="ai-content-provider"]') : null;
      return (m && m.getAttribute('content')) || '';
    }

    function markAiGenerated(node) {
      if (!node) { return; }
      node.setAttribute('data-ai-generated', '1');
      var p = aiProvider();
      if (p) { node.setAttribute('data-ai-provider', p); }
    }

    /* 免责条：从提问那刻就在位（终态才插入会让卡片突然长高） */
    function answerTag() {
      var tag = el('p', 'tool-feedback-answer-tag');
      tag.appendChild(iconEl('alert-circle'));
      tag.appendChild(span('tool-feedback-answer-tag-text',
        '由 AI 生成，仅供参考；它不评判你，也替代不了专业的医疗、法律或心理帮助。'));
      return tag;
    }

    /* 光标放进块级文字容器末尾（行内元素夹块级之间会生成匿名块、白占一行） */
    function placeCaret(turn) {
      if (!turn.caret) { return; }
      var kids = turn.body.children;
      var target = null;
      for (var i = kids.length - 1; i >= 0; i--) {
        if (String(kids[i].className || '').indexOf('tool-feedback-caret') > -1) { continue; }
        target = kids[i];
        break;
      }
      var tag = target ? String(target.tagName).toLowerCase() : '';
      if (tag === 'ul' || tag === 'ol') { target = target.lastElementChild || target; }
      if (tag === 'hr') { target = null; }
      (target || turn.body).appendChild(turn.caret);
    }

    function renderBody(turn, text) {
      var TUI = global.ToolUI || {};
      turn.body.className = 'tool-feedback-answer';
      if (typeof TUI.md === 'function') { TUI.md(turn.body, text, { optimistic: turn.streaming }); } else { turn.body.textContent = text; }
      placeCaret(turn);
    }

    /* 大增量平滑展开（代理攒包/非流式降级整段插入时防瞬移） */
    function smoothGrow(node, prevH) {
      try {
        if (!(prevH > 0) || typeof node.animate !== 'function') { return; }
        var nextH = node.getBoundingClientRect().height;
        if (nextH - prevH < 80) { return; }
        node.style.overflow = 'hidden';
        var anim = node.animate(
          [{ height: prevH + 'px' }, { height: nextH + 'px' }],
          { duration: 240, easing: 'ease-out' }
        );
        function unlock() { if (node.style.overflow === 'hidden') { node.style.overflow = ''; } }
        anim.onfinish = unlock;
        anim.oncancel = unlock;
      } catch (e) { /* 老环境直接跳变 */ }
    }

    function renderPending(turn) {
      turn.body.className = 'tool-feedback-answer is-pending';
      turn.body.textContent = '';
      var p = el('p', 'tool-md-p');
      p.appendChild(dotsEl());
      p.appendChild(span('tool-feedback-pending-text',
        aiOn() ? 'AI 正在读你的填写与纠结，生成中…' : '正在提交…'));
      turn.body.appendChild(p);
      placeCaret(turn);
    }

    function dotsEl() {
      var wrap = el('span', 'tool-feedback-dots');
      wrap.setAttribute('aria-hidden', 'true');
      wrap.appendChild(el('span', ''));
      wrap.appendChild(el('span', ''));
      wrap.appendChild(el('span', ''));
      return wrap;
    }

    /* 起一轮：问题立刻上屏；免责条与评价行从一开始就占住高度（布局零位移口径） */
    function startTurn(question) {
      if (!turnsBox) { return null; }
      var root = el('div', 'tool-feedback-turn is-streaming');
      markAiGenerated(root);

      var quote = el('p', 'tool-feedback-quote');
      quote.appendChild(span('tool-feedback-quote-label', '你的问题：'));
      quote.appendChild(doc.createTextNode(question));
      root.appendChild(quote);

      var body = el('div', 'tool-feedback-answer is-pending');
      root.appendChild(body);

      /* 光标创建时不带 is-on：生成中动效由三点脉冲负责，首个分片到达才点亮 */
      var turn = { root: root, body: body, text: '', id: 0, pending: true, streaming: true, caret: el('span', 'tool-feedback-caret') };
      renderPending(turn);
      root.appendChild(answerTag());
      turn.rate = rateRow(function () { return turn.id; });
      root.appendChild(turn.rate);

      turnsBox.appendChild(root);
      turnsBox.setAttribute('aria-busy', 'true');
      turnsBox.scrollTop = turnsBox.scrollHeight;
      return turn;
    }

    /* 分片到达：对累积后的整段重新渲染（Markdown 成对标记可能被切成两半） */
    function appendChunk(turn, delta) {
      if (!turn) { return; }
      turn.pending = false;
      if (turn.caret) { turn.caret.className = 'tool-feedback-caret is-on'; }
      var prevH = 0;
      try { prevH = turn.body.getBoundingClientRect().height; } catch (e) { /* 无布局环境恒 0 */ }
      turn.text = (turn.text || '') + delta;
      renderBody(turn, turn.text);
      smoothGrow(turn.body, prevH);
      if (turnsBox) { turnsBox.scrollTop = turnsBox.scrollHeight; }
    }

    /* 收尾：解锁评价 + 换正文；answer 为空则整轮回滚 */
    function finishTurn(turn, answer, id) {
      if (!turn) { return null; }
      if (!answer) {
        if (turn.root.parentNode) { turn.root.parentNode.removeChild(turn.root); }
        if (turnsBox) { turnsBox.removeAttribute('aria-busy'); }
        return null;
      }
      turn.id = id || turn.id;
      if (turn.id) { turn.root.setAttribute('data-ai-content-id', String(turn.id)); }
      turn.pending = false;
      turn.streaming = false;   // 先摘流式标记再渲染：终态走严格口径
      turn.text = answer;
      renderBody(turn, answer);
      if (turn.caret) { turn.caret.className = 'tool-feedback-caret'; }
      turn.root.className = 'tool-feedback-turn';
      if (turn.rate) {
        if (turn.id) {
          turn.rate.className = 'tool-feedback-rate';
          var btns = turn.rate.querySelectorAll('button');
          for (var i = 0; i < btns.length; i++) { btns[i].disabled = false; }
        } else {
          /* 没有记录 id 就评不了：宁可不显示这一行，也不给「点了没反应」的按钮 */
          if (turn.rate.parentNode) { turn.rate.parentNode.removeChild(turn.rate); }
          turn.rate = null;
        }
      }
      if (turnsBox) {
        turnsBox.removeAttribute('aria-busy');
        turnsBox.scrollTop = turnsBox.scrollHeight;
      }
      return turn;
    }

    function rollbackTurn(turn, isFirst) {
      if (!turn || String(turn.text || '') !== '' || !turn.root.parentNode) { return; }
      turn.root.parentNode.removeChild(turn.root);
      if (turnsBox) { turnsBox.removeAttribute('aria-busy'); }
      if (isFirst && form) { form.hidden = false; }
    }

    function history() {
      var out = [];
      for (var i = 0; i < turns.length; i++) {
        if (turns[i].a) { out.push({ q: turns[i].q, a: turns[i].a }); }
      }
      return out.slice(-3);
    }

    /* 提问主链路（首问与追问共用） */
    function askQuestion(raw, isFirst) {
      if (busy || (isFirst && finished)) { return; }
      var q = String(raw == null ? '' : raw).trim();
      if (q === '') {
        inlineError('把你的纠结写一句给它——比如「我纠结的不是钱，是怕后悔」。');
        if (text) { text.focus(); }
        return;
      }
      inlineError('');
      setBusy(true);

      var payload = {
        slug: pageSlug(),
        solved: 0,
        question: q.slice(0, 500),
        context: collectContext(section),
        history: history()
      };

      /* 提交即切会话态把问题上屏（首片实测要几秒）；只在后端真会调 AI 时切换 */
      if (isFirst && aiOn()) { showChat(); }
      var turn = startTurn(q);

      var pending = streamOn()
        ? postStream(endpoint, payload, function (delta) {
            appendChunk(turn, delta);
          }, function (id) {
            if (turn && id) { turn.id = id; }
          })
        : postJSON(endpoint, payload);

      pending.then(function (res) {
        setBusy(false);
        if (!res || !res.ok) {
          /* 失败但已吐出内容：字留住、轮次收尾（否则永远停在「生成中」） */
          if (turn && String(turn.text || '') !== '') {
            finished = true;
            turns.push({ q: q, a: String(res.answer || turn.text) });
            showChat();
            finishTurn(turn, String(res.answer || turn.text), res.id);
            toast(res && res.code === 'fbAborted' ? '回答中断，已输出的部分留住了；可继续追问。' : '回答可能没输出完整，可再问一次。');
            return;
          }
          rollbackTurn(turn, isFirst);
          inlineError(failMsg(res, '提交失败，请稍后再试'));
          return;
        }
        if (!res.answer) {
          var why = skipMsg(res.skip);
          if (turn && turn.root.parentNode) { turn.root.parentNode.removeChild(turn.root); }
          if (turnsBox) { turnsBox.removeAttribute('aria-busy'); }
          if (isFirst) {
            finished = true;
            finishThanks(why || '已收到。你的纠结记下了——问卷与打印不受影响。', why ? 'warn' : '');
          } else {
            toast(why || 'AI 暂时没能回答，稍后再试');
          }
          return;
        }
        finished = true;
        var answer = String(res.answer);
        if (isFirst && text) { text.value = ''; }
        if (ask) { ask.value = ''; }
        turns.push({ q: q, a: answer });
        showChat();
        finishTurn(turn, answer, res.id);
        if (res.truncated) { toast('回答可能没输出完整，可再问一次。'); }
        focusQuiet(ask);   // 不能裸 focus：卡片撑高后追问框常在视口外
      }).catch(function () {
        setBusy(false);
        rollbackTurn(turn, isFirst);
        inlineError('提交失败，请稍后再试');
      });
    }

    if (send) {
      send.addEventListener('click', function () { askQuestion(text ? text.value : '', true); });
    }
    if (askSend) {
      askSend.addEventListener('click', function () { askQuestion(ask ? ask.value : '', false); });
    }
    /* Ctrl / ⌘ + Enter 发送（两个输入框通用） */
    function bindKeys(node, getter, isFirst) {
      if (!node) { return; }
      node.addEventListener('keydown', function (ev) {
        if ((ev.ctrlKey || ev.metaKey) && ev.key === 'Enter') {
          ev.preventDefault();
          askQuestion(getter(), isFirst);
        }
      });
    }
    bindKeys(text, function () { return text ? text.value : ''; }, true);
    bindKeys(ask, function () { return ask ? ask.value : ''; }, false);
  }

  /* 结果生成后引导语动态化（decide.js 生成时调）：把平衡单的关键信息
     （总分 + 分差 Top2 维度）带进 AI 入口文案，把「看结果」和「聊纠结」接起来。
     红线：只陈述纸面上的信息，不下「你该走/该留」的结论（与判分文案红线一致）。
     只替换首段文本节点，保留 data-ai-missing span（fbAi=0 的提示位） */
  function refreshIntro() {
    var intro = doc.querySelector('[data-ai-intro]');
    var last = global.DZ_LAST || null;
    if (!intro || !last || !last.dims || !last.dims.length) { return; }
    /* 两难标签走场景 cfg.resultUI（#127 起），缺省老版口径「留下/离开」 */
    var scUi = ((global.DZ_SCENES || {})[last.slug] || {}).resultUI || {};
    var stayName = scUi.stayName || '留下';
    var goName = scUi.goName || '离开';
    var sorted = last.dims.slice().sort(function (a, b) { return Math.abs(b.gap) - Math.abs(a.gap); });
    var top = [];
    for (var d = 0; d < sorted.length && top.length < 2; d++) {
      if (!sorted[d].gap) { break; }
      top.push('【' + sorted[d].label + '】' + (sorted[d].gap > 0 ? goName + '比' + stayName + '高 ' : stayName + '比' + goName + '高 ') + Math.abs(sorted[d].gap) + ' 分');
    }
    if (!top.length) { return; }
    var msg = '你的平衡单出来了：「' + stayName + '」合计 ' + last.stay + ' 分、「' + goName + '」合计 ' + last.leave +
      ' 分，分差主要在' + top.join('、') + '。想把这块拿出来聊聊吗？它只帮你理思路，不替你选。回答由 AI 生成，仅供参考';
    if (intro.firstChild && intro.firstChild.nodeType === 3) { intro.firstChild.nodeValue = msg; }
    else { intro.insertBefore(doc.createTextNode(msg), intro.firstChild); }
  }

  var sections = doc.querySelectorAll('[data-feedback]');
  for (var i = 0; i < sections.length; i++) { mountFeedback(sections[i]); }

  global.DZ_AI = { refreshIntro: refreshIntro };

})(typeof window !== 'undefined' ? window : globalThis);
